export default {
  present: 'Til stede',
  not_present: 'Ikke til stede',
  vacation_free_time: 'Ferie/fri',
  not_arrived: 'Ikke kommet',
  sick: 'Syg',
  missing_checkout: 'Tjek ud mangler',
  come: 'Kommer',
  came: 'Kom',
  go: 'Går',
  went: 'Gik',
  spare_time_activity_note: 'Fritidsaktivitets bemærkning',
  vacation_free_time_note: 'Ferie/fri bemærkning',
  daily_note: 'Dagens bemærkning',
  overlapping_template_confirmation:
    'Hvis du fortsætter, vil den nye gentagelse overskrive de tider, der allerede er oprettet.',
  statistic_info:
    'Her kan du se informationer om, hvem der er kommet, er syg, har ferie/fri eller ikke er kommet for en given periode. Du kan vælge hele institutionen eller en specifik gruppe.<br/>Du kan både se statistik tilbage i tiden eller vælge en fremtidig dato og se det forventede antal børn.',
  cannot_calculate_not_arrived:
    'Antallet af "Ikke kommet" er inkluderet i "Til stede". Information om "Ikke kommet" i denne oversigt er kun tilgængelig fra den 20 juni 2026 og frem.',
};
